
export const INPUT_NUMBER_DATA = {
    INPUT_1: {
        id: 0,
        name: 'INPUT 1'
    },
    INPUT_2: {
        id: 1,
        name: 'INPUT 2'
    },
    INPUT_3: {
        id: 2,
        name: 'INPUT 3'
    },
    INPUT_4: {
        id: 3,
        name: 'INPUT 4'
    }
}

export const INPUT_DATA = {
    hidSioId: null,
    name: null,
    number: null,
    controllerId: null,
    typeConnection: null,
    toAddEdit: function () {
        return {
            hidSioId: this.hidSioId,
            name: this.name,
            number: this.number,
            typeConnection: this.typeConnection
        };
    },
    isValid: function () {
        return this.hidSioId !== null &&
            this.name !== null &&
            this.name !== '' &&
            this.number !== null &&
            this.controllerId !== null &&
            this.typeConnection !== null;
    },
    setToTable: function (data, sioName) {
        return {
            id: data.id,
            hidSioId: data.hidSioId,
            hidSioName: sioName,
            name: data.name,
            number: data.number,
            deviceType: data.deviceType,
            sioType: data.sioType,
            typeConnection: data.typeConnection
        }
    }
};

export const CONNECTION_TYPE_MODEL = {
    0: {
        name: "NORMALLY_CLOSED",
        trans: "normally_closed"
    },
    1: {
        name: "NORMALLY_OPEN",
        trans: "normally_open"
    }
}
